import React from "react";
import { Modal, Button, Card, Alert } from "react-bootstrap";
import { formatDate } from "../../../../utils";

function CaseStatusModal({
  responseCaseStatus,
  backlogProceedingsList,
  backlogDocumentsList,
  errorString,
  submitError,
  submitErrorProceeding,
  submitErrorDocument,
  show,
  handleClose,
  benchName,
}) {
  // If there's an error in the API response, display the error message
  if (submitError || submitErrorProceeding || submitErrorDocument) {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Modal.Title>Error</Modal.Title>
          <Button className="btn-secondary">X</Button>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">
            {responseCaseStatus?.error ||
              "An error occurred. Please try again."}
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's an error message in the API response, display the error message
  if (errorString !== "") {
    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header onClick={handleClose}>
          <Button className="btn-secondary">X</Button>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="danger">{errorString}</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // If there's no data, do not render anything
  if (!responseCaseStatus || !responseCaseStatus.data) return null;

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header onClick={handleClose}>
        <Modal.Title>Case Status Details</Modal.Title>
        <Button className="btn-secondary">X</Button>
      </Modal.Header>
      <Modal.Body>
        {/* case details */}
        {responseCaseStatus.data.map((caseDetail) => (
          <Card className="mb-3" key={caseDetail.case_no}>
            <Card.Body>
              <Card.Title className="mb-2 rct-secondry-heading">
                {caseDetail.case_title}
              </Card.Title>
              <Card.Text>
                <div className="titlesec mt-3">
                  <h4 className="httxt">Case Status</h4>
                </div>
                <table className="table table-striped table-bordered case-table">
                  <tbody>
                    <tr>
                      <th>
                        <span>Main Filing No.</span>
                      </th>
                      <td> {caseDetail.filing_no}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Date of Filing</span>
                      </th>
                      <td> {caseDetail.date_of_filing}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Case No.</span>
                      </th>
                      <td> {caseDetail.case_no}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Court No</span>
                      </th>
                      <td> {caseDetail.court_no}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Status</span>
                      </th>
                      <td> {caseDetail.c_status}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Date Of Registration</span>
                      </th>
                      <td> {caseDetail.case_registered_date}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Amount Claim Rs.</span>
                      </th>
                      <td> {caseDetail.claim_amount}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Station From</span>
                      </th>
                      <td> {caseDetail.station_from}</td>
                    </tr>
                    <tr>
                      <th>
                        <span>Station To</span>
                      </th>
                      <td> {caseDetail.station_to}</td>
                    </tr>
                  </tbody>
                </table>
                <div className="titlesec mt-3">
                  <h4 className="httxt">Accident Details</h4>
                </div>
                <table className="table table-striped table-bordered case-table">
                  <tr>
                    <th>
                      <span>Cause</span>
                    </th>
                    <td>{caseDetail.cause_name}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Sub Cause</span>
                    </th>
                    <td>{caseDetail.sub_cause_name}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Place Of Accident</span>
                    </th>
                    <td>{caseDetail.accident_occur}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Date Of Accident</span>
                    </th>
                    <td>{caseDetail.date_of_accident}</td>
                  </tr>
                </table>
                <div className="titlesec mt-3">
                  <h4 className="httxt">Victim Details</h4>
                </div>
                <table className="table table-striped table-bordered case-table">
                  <tr>
                    <th>
                      <span>Victim Name</span>
                    </th>
                    <td>{caseDetail.victim_name}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Victim Address</span>
                    </th>
                    <td>{caseDetail.victim_address}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Victim Mobile</span>
                    </th>
                    <td>{caseDetail.victim_mobile}</td>
                  </tr>
                  <tr>
                    <th>
                      <span>Victim's Father/Husband Name</span>
                    </th>
                    <td>{caseDetail.victim_father_husband_name}</td>
                  </tr>
                </table>
                <div className="titlesec mt-3">
                  <h4 className="httxt">Applicants' Details</h4>
                </div>
                <table className="table table-striped table-bordered case-table">
                  <tr>
                    <th>
                      <span>Name & Address</span>
                    </th>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: caseDetail.pet_names,
                        }}
                      ></div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Advocate</span>
                    </th>
                    <td>{caseDetail.pet_adv_name}</td>
                  </tr>
                </table>
                <div className="titlesec mt-3">
                  <h4 className="httxt">Respondents' Details</h4>
                </div>
                <table className="table table-striped table-bordered case-table">
                  <tr>
                    <th>
                      <span>Name</span>
                    </th>
                    <td>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: caseDetail.res_names,
                        }}
                      ></div>
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <span>Advocate</span>
                    </th>
                    <td>{caseDetail.res_adv_name}</td>
                  </tr>
                </table>
              </Card.Text>
            </Card.Body>
          </Card>
        ))}
        {/* case proceedings details */}
        {responseCaseStatus.allProceeding &&
          responseCaseStatus.allProceeding.length > 0 && (
            <>
              <div className="titlesec mt-3">
                <h4 className="httxt">Case Proceeding Details</h4>
              </div>
              <table className="table table-striped table-bordered common-table modal-custom-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Bench Name</th>
                    <th>Hearing Date</th>
                    <th>Purpose</th>
                    <th>Next Listing/ Disposal Date</th>
                    <th>Next Listing Purpose</th>
                    <th>Orders</th>
                    <th>Updated on</th>
                  </tr>
                </thead>
                <tbody>
                  {responseCaseStatus.allProceeding.map((proceeding, index) => {
                    // Only render rows where order_type is "J"
                    if (proceeding.order_type !== "J") {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{benchName} BENCH</td>
                          <td>{proceeding.listing_date}</td>
                          <td>{proceeding.listing_purpose}</td>
                          <td>{proceeding.next_listing_date}</td>
                          <td>{proceeding.today_action}</td>
                          <td>
                            {proceeding.file_name ? (
                              <a
                                href={`${process.env.REACT_APP_API_FILE_URL}/displayOrder/${proceeding.filing_no}/${proceeding.hash_filename}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                View Order
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                          <td>{proceeding.last_update}</td>
                        </tr>
                      );
                    }
                    return null; // If order_type is not "J", do not render anything
                  })}
                </tbody>
              </table>
            </>
          )}

        {/* backlog proceedings list */}
        {backlogProceedingsList?.data?.length > 0 && (
          <>
            <div className="titlesec mt-3">
              <h4 className="httxt">Backlog Proceeding List</h4>
            </div>
            <table className="table table-striped table-bordered common-table modal-custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Listing Date</th>
                  <th>Listing Purpose</th>
                  <th>Next Listing Date</th>
                  <th>Next Listing Purpose</th>
                  <th>Court No</th>
                  <th>Bench Nature</th>
                  <th>Judge Name</th>
                </tr>
              </thead>
              <tbody>
                {backlogProceedingsList.data.map((proceeding, index) => {
                  // Only render rows where order_type is "J"
                  if (proceeding.order_type !== "J") {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{formatDate(proceeding.listing_date)}</td>
                        <td>{proceeding.listing_purpose}</td>
                        <td>{formatDate(proceeding.next_listing_date)}</td>
                        <td>{proceeding.next_listing_purpose}</td>
                        <td>{proceeding.court_no}</td>
                        <td>{proceeding.bench_nature}</td>
                        <td>{proceeding.judge_name}</td>
                      </tr>
                    );
                  }
                  return null; // If order_type is not "J", do not render anything
                })}
              </tbody>
            </table>
          </>
        )}

        {/* backlog documents list */}
        {backlogDocumentsList?.data?.length > 0 && (
          <>
            <div className="titlesec mt-3">
              <h4 className="httxt">Backlog Proceeding List</h4>
            </div>
            <table className="table table-striped table-bordered common-table modal-custom-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Document Name</th>
                  <th>Document Type</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {backlogDocumentsList.data.map((proceeding, index) => {
                  // Only render rows where order_type is "J"
                  if (proceeding.order_type !== "J") {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{proceeding.ducument_name}</td>
                        <td>{proceeding.document_type}</td>
                        <td>
                          {proceeding.document_file_name ? (
                            <a
                              href={`${process.env.REACT_APP_API_FILE_URL}/backlog_document/${proceeding.filing_no}/${proceeding.hash_filename}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View Order
                            </a>
                          ) : (
                            "N/A"
                          )}
                        </td>
                        {/* <td>{proceeding.document_file_name}</td> */}
                      </tr>
                    );
                  }
                  return null; // If order_type is not "J", do not render anything
                })}
              </tbody>
            </table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CaseStatusModal;
